import { Monitor, Moon, Sun } from "lucide-react";
import { useAppTheme } from "../../context/ThemeContext";

const OPTIONS = [
  { id: "system", label: "Tema: come il sistema", short: "Sistema", Icon: Monitor },
  { id: "light", label: "Tema chiaro", short: "Chiaro", Icon: Sun },
  { id: "dark", label: "Tema scuro", short: "Scuro", Icon: Moon },
];

/**
 * Scelta del tema in Drive: Sistema (default, segue il telefono in tempo reale) / Chiaro / Scuro.
 * Pulsanti da 44px, solo icona con aria-label (spazio ridotto nell'header).
 */
export default function DriveThemeSwitch({ className = "" }) {
  const { theme, setTheme } = useAppTheme();
  return (
    <div
      role="radiogroup"
      aria-label="Tema"
      data-testid="drive-theme-switch"
      className={`inline-flex items-center rounded-full border border-slate-200 bg-white/80 p-0.5 dark:border-slate-700 dark:bg-slate-800/80 ${className}`}
    >
      {OPTIONS.map(({ id, label, short, Icon }) => {
        const active = theme === id;
        return (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={label}
            title={short}
            data-theme-option={id}
            onClick={() => setTheme(id)}
            className={`inline-flex h-11 w-11 items-center justify-center rounded-full transition-colors ${
              active
                ? "bg-indigo-600 text-white"
                : "text-slate-500 active:bg-slate-100 dark:text-slate-400 dark:active:bg-slate-700"
            }`}
          >
            <Icon className="h-[18px] w-[18px]" aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
}
